import { useTranslation } from 'react-i18next';
import CountryLabel from '../../../components/CountryLabel/CountryLabel';
import { formatNumber } from '../../../core/helpers';
import { NormalizedFCTransfer } from './SetupCheck';
import { ReactComponent as InfoIcon } from '../../../icons/info-outline.svg';
import Button from '../../../components/Button';

interface Props {
  item: NormalizedFCTransfer;
  homeCountry: string | undefined;
  openModal: () => void;
}

export default function NewFCTransferItem({
  item,
  homeCountry,
  openModal,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className='mb-3 border-top pt-2'>
      <CountryLabel country={item.country} className='mb-2' />
      <div className='fw-600 d-flex justify-content-between w-100'>
        <div>{t('Departures')}</div>
        <div>{formatNumber(item.departures.total)}</div>
      </div>
      <div className='mb-2'>
        {item.departures.countries.map((c) => (
          <div
            key={c}
            className='me-2 SetupCheck__FCTransferCountryCol d-inline-block'
          >
            {t(c)}
          </div>
        ))}
      </div>
      <div className='fw-600 d-flex justify-content-between w-100'>
        <div>{t('Arrivals')}</div>
        <div>{formatNumber(item.arrivals.total)}</div>
      </div>
      <div className='mb-2'>
        {item.arrivals.countries.map((c) => (
          <div
            key={c}
            className='me-2 SetupCheck__FCTransferCountryCol d-inline-block'
          >
            {t(c)}
          </div>
        ))}
      </div>
      {homeCountry === item.country && (
        <div>
          {t('All')}&nbsp;
          <Button styling='naked-blue' onClick={openModal}>
            {formatNumber(item.arrivals.total + item.departures.total)}{' '}
            {t('transactions')}
          </Button>
          &nbsp;
          <InfoIcon
            className='SetupCheck__info'
            style={{
              marginTop: -2,
            }}
          />
          &nbsp;
          {t(
            'must be included into local *country* filing by tax advisor'
          ).replace('*country*', item.country)}
        </div>
      )}
    </div>
  );
}
